/* cx-gallery-mobile.js — verlour port of bymayfield's mb-gallery-peek.js (2026-07-08)
 * Mobile PDP gallery → Swiper loop carousel: centered slide with a peek of the
 * previous AND next photo on both sides + espresso dots. Native touch-swipe.
 * Desktop (>=750px) keeps Dawn's own gallery untouched (Swiper torn down).
 * Requires mb-swiper.js/.css (vendored Swiper 11, copied from bymayfield).
 * Nav/zoom buttons are created but hidden by CSS (Mayberry final state:
 * swipe + dots only; Dawn's native lightbox button handles zoom).
 */
(function () {
  'use strict';
  var MOBILE = '(max-width: 749px)';
  function isMobile() { return window.matchMedia(MOBILE).matches; }
  function items(list) { return Array.prototype.slice.call(list.querySelectorAll('.product__media-item')); }

  function build(list) {
    if (list.__cxSwiperInst || typeof window.Swiper !== 'function') return;
    var its = items(list);
    if (its.length < 2) return;

    list.classList.add('swiper-wrapper');
    its.forEach(function (it) { it.classList.add('swiper-slide'); });

    var swEl = document.createElement('div');
    swEl.className = 'swiper mb-gal-swiper';
    list.parentNode.insertBefore(swEl, list);
    swEl.appendChild(list);

    var pag = document.createElement('div');
    pag.className = 'swiper-pagination mb-gal-pag';
    swEl.appendChild(pag);
    list.__cxSwiperEl = swEl;

    list.__cxSwiperInst = new window.Swiper(swEl, {
      loop: true,
      centeredSlides: true,
      slidesPerView: 'auto',
      spaceBetween: 0,
      watchOverflow: true,
      roundLengths: true, /* integer widths — fractional 88vw slides drift the centering a few px per swipe */
      pagination: { el: pag, clickable: true }
    });

    /* re-measure once layout settles + whenever a lazy image finishes loading,
       otherwise the snap grid is computed from stale slide sizes and the
       carousel ends up visibly off-center (worst at the last slide) */
    var refresh = function () {
      try { if (list.__cxSwiperInst) list.__cxSwiperInst.update(); } catch (e) {}
    };
    window.setTimeout(refresh, 350);
    window.setTimeout(refresh, 1200);
    swEl.querySelectorAll('img').forEach(function (img) {
      if (!img.complete) img.addEventListener('load', refresh, { once: true });
    });
  }

  function teardown(list) {
    if (list.__cxSwiperPoll) { window.clearInterval(list.__cxSwiperPoll); list.__cxSwiperPoll = null; }
    if (list.__cxSwiperInst) {
      try { list.__cxSwiperInst.destroy(true, true); } catch (e) {}
      list.__cxSwiperInst = null;
    }
    var swEl = list.__cxSwiperEl;
    if (swEl && swEl.parentNode) {
      var pag = swEl.querySelector('.mb-gal-pag');
      if (pag) pag.remove();
      swEl.parentNode.insertBefore(list, swEl);
      swEl.remove();
    }
    list.__cxSwiperEl = null;
    list.classList.remove('swiper-wrapper');
    items(list).forEach(function (it) { it.classList.remove('swiper-slide'); });
  }

  function sync(list) {
    if (isMobile()) {
      if (!list.__cxSwiperInst) {
        if (typeof window.Swiper === 'function') {
          build(list);
        } else {
          /* load-order race: poll ~2s max for window.Swiper, then re-sync */
          if (!list.__cxSwiperPoll) {
            var tries = 0;
            list.__cxSwiperPoll = window.setInterval(function () {
              tries++;
              if (typeof window.Swiper === 'function' || tries > 40 || !isMobile()) {
                window.clearInterval(list.__cxSwiperPoll);
                list.__cxSwiperPoll = null;
                sync(list);
              }
            }, 50);
          }
        }
      }
    } else if (list.__cxSwiperInst) {
      teardown(list);
    }
  }

  /* variant change (e.g. color swatch) → slide the carousel to the variant's photo */
  function bindVariant(list) {
    if (list.__cxVarBound) return;
    list.__cxVarBound = true;
    var section = list.closest('.shopify-section') || document;
    section.addEventListener('change', function (e) {
      if (!list.__cxSwiperInst) return;
      if (e.target && e.target.closest && e.target.closest('variant-selects, variant-radios, .product-form__input')) {
        window.setTimeout(function () {
          var active = list.querySelector('.product__media-item[aria-hidden="false"], .product__media-item.is-active');
          if (active) {
            var idx = active.getAttribute('data-swiper-slide-index');
            if (idx != null) { try { list.__cxSwiperInst.slideToLoop(parseInt(idx, 10)); } catch (e2) {} }
          }
        }, 260);
      }
    });
  }

  /* single Mayberry-style zoom: white magnifier circle bottom-right ON the
     centred photo; opens Dawn's lightbox for whichever slide is centred */
  function addZoom(list) {
    if (list.__cxZoomBtn) return;
    if (items(list).length < 1) return;
    var host = list.parentElement;
    if (!host) return;
    var zoom = document.createElement('button');
    zoom.type = 'button';
    zoom.className = 'mb-gal-zoom2';
    zoom.setAttribute('aria-label', 'Zoom');
    zoom.innerHTML = '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><circle cx="10.5" cy="10.5" r="6.5" fill="none" stroke="currentColor" stroke-width="2"/><path d="M20 20 L15.5 15.5" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
    zoom.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      var arr = items(list);
      if (!arr.length) return;
      var listRect = list.getBoundingClientRect();
      var center = listRect.left + listRect.width / 2;
      var best = arr[0], bestD = Infinity;
      arr.forEach(function (it) {
        var r = it.getBoundingClientRect();
        var d = Math.abs((r.left + r.width / 2) - center);
        if (d < bestD) { bestD = d; best = it; }
      });
      var b = best && best.querySelector('.product__media-toggle, modal-opener button, .product__modal-opener button');
      if (b) b.click();
    });
    list.__cxZoomBtn = zoom;
    // anchor to the swiper wrapper (position:relative) so it rides the centred slide
    var sw = list.closest('.mb-gal-swiper') || host;
    sw.appendChild(zoom);
  }

  function run() {
    document.querySelectorAll('.product__media-list').forEach(function (l) { sync(l); if (l.__cxSwiperInst) addZoom(l); });
  }
  function init() {
    document.querySelectorAll('.product__media-list').forEach(function (l) { bindVariant(l); });
    run();
  }

  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
  window.addEventListener('resize', run);
  document.addEventListener('shopify:section:load', init);
})();
